var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.isRestricted
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        size: "256"
                      }
                    },
                    [_vm._v(" mdi-alert ")]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("gg-card-title", [
                    _vm._v(" This feature requires an Upgrade ")
                  ])
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "subtitle-1 text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _vm._v(
                    " The ability to host multiple domain names on your account is not available on your current subscription. You will need to upgrade your plan. "
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        to: {
                          name: "support_ticketnew",
                          query: {
                            sbj: "Upgrade my account",
                            d: "Sales",
                            s: _vm.$attrs.hostingid
                          }
                        }
                      }
                    },
                    [_vm._v(" Upgrade now ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("create-addon-domain-form", {
                    on: {
                      "addondomain-created": _vm.reloadTable
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("addon-domains-table", {
                    attrs: {
                      "table-should-be-reloaded": _vm.tableShouldBeReloaded
                    },
                    on: {
                      "table-reloaded": _vm.tableReloaded
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }